<div class="coa-diagnostic-fix">
  <table class="gt-reclass-table table table-condensed">
    <thead>
      <tr>
        <th>COA Diagnostic Fix</th>
      </tr>
    </thead>
  </table>

  <div class="coa-form">
    <div class="coa-form-row">
      <div class="coa-field">
        <label class="coa-field-label">Tax Year</label>
        @if (!loadingTaxYears) {
          <select gtwSearchableSelect
            class="form-control coa-field-control"
            [(ngModel)]="selectedTaxYear"
            (ngModelChange)="onTaxYearChange()">
            <option value="">-- Select --</option>
            @for (taxyr of filteredTaxYearData; track $index) {
              <option
                [value]="taxyr.CODE_DISP_DESC">
                {{ taxyr.CODE_DISP_DESC }}
              </option>
            }
          </select>
        }
        @if (loadingTaxYears) {
          <div class="loading-select loading-select--tax-year">
            <input type="text" class="form-control" disabled placeholder="Loading...">
            <span class="loading-select-icon"><i class="fa fa-spinner fa-pulse"></i></span>
          </div>
        }
      </div>

      @if (showScenario || loadingScenarios) {
        <div class="coa-field">
          <label class="coa-field-label">Scenario</label>
          @if (!loadingScenarios) {
            <select gtwSearchableSelect
              class="form-control coa-field-control coa-field-control--scenario"
              [(ngModel)]="selectedScenario"
              (ngModelChange)="onScenarioChange()">
              <option value="">-- Select --</option>
              @for (option of scenarioDropDown; track $index) {
                <option
                  [value]="option.VALUE">
                  {{ option.LABEL }}
                </option>
              }
            </select>
          }
          @if (loadingScenarios) {
            <div class="loading-select loading-select--scenario">
              <input type="text" class="form-control" disabled placeholder="Loading...">
              <span class="loading-select-icon"><i class="fa fa-spinner fa-pulse"></i></span>
            </div>
          }
        </div>
      }
    </div>

    <div class="coa-form-row coa-form-row--accounts">
      <div class="coa-field coa-field--accounts">
        <label class="coa-field-label">COA Diagnostic Fix</label>
        @if (!loadingAccounts) {
          <ap-dropdown
            #acctMultiSelect
            class="coa-multiselect"
            [selectType]="'multiple'" [enableNgContent]="false"
            [list]="dropdownLists['accounts']" [optionName]="'ACCT_DESC'" [optionValue]="'ACCT_KEY'"
            [title]="'Select Accounts'" [inputAriaLabel]="'Select Accounts'" [hideTitleOnInput]="true"
            [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
            (onFilterResult)="onDropdownFilterResult('accounts', $event)"
            [(ngModel)]="selectedFromAcctKey"
            [disabled]="!selectedScenario || localAccts.length === 0">
          </ap-dropdown>
        }
        @if (loadingAccounts) {
          <div class="loading-select loading-select--accounts">
            <input type="text" class="form-control" disabled placeholder="Loading accounts...">
            <span class="loading-select-icon"><i class="fa fa-spinner fa-pulse"></i></span>
          </div>
        }
      </div>

      <div class="coa-field coa-field--action">
        <button class="btn btn-info btn-sm"
          type="button"
          [disabled]="examScenario"
          (click)="confirmFixCoaMapping()">
          Fix COA Mapping
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation Dialog -->
@if (showConfirmDialog) {
  <div class="confirmation-modal-overlay">
    <gtw-confirmation-modal
      [config]="confirmModalConfig"
      [visible]="false"
      (confirmed)="onConfirmYes()"
      (cancelled)="onConfirmNo()"
      (closed)="onConfirmNo()">
    </gtw-confirmation-modal>
  </div>
}
